import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Serverurl from './Apiurl';
import IconButton from '@mui/material/IconButton';
export default class Forgot extends Component {
	constructor(props) {
    super(props);
	this.state = {redirect:false,pagename:'',pnlmsg:false,msgtext:'',errormessage:'',erroropen:false,alerttype:'error',btndisabled:false,btntext:'Submit',
	emailid:''}
	
	}
	handleChange = event => {
let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 };
 handleErrorclose=(event)=>{
	  
	this.setState({erroropen: false});  
  }

componentDidMount() {
	let search = window.location.href;
		
	let UserId = this.getParameterByName('UserId',search);
	if(UserId!==null)
	{
	this.setState({emailid: UserId});
	}	
}
getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
OnclickForgot =(event)=>{
	 event.preventDefault();
	  let remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/; 
	 let emailid = this.state.emailid;
	
	     if(emailid==="")
{
	this.setState({errormessage:"Please Enter Email Id.",erroropen:true});
	return false;
}
 if (!remail.test(emailid)) {
	  this.setState({errormessage:"Please Enter valid Email.",erroropen:true});
	  window.scrollTo({
          top: 0
      })
	return false;
  }
   var formData = new FormData();
   this.setState({btndisabled:true,btntext:'Processing...',errormessage:'',erroropen:false});
    formData.append('action','forgot')
		formData.append('st_emailid',emailid)
	
	
	 axios.post(Serverurl+"ajaxstaff.php", formData, { 
	 }).then(res => {
		 this.setState({btndisabled:false,btntext:'Submit' });
		 let strreturn=res.data 	;	 
 

 if (strreturn === -1)
        {	 
			this.setState({pnlmsg:true,msgtext:"This Email does not belongs to any account!  Make sure that it is typed correctly."})
			window.scrollTo({        top: 0     })
		}
		else
		{
			
			if(strreturn===1)
		{
			 localStorage.setItem("AYEmail",emailid);
					this.setState({redirect:true,pagename:"/Resetpassword",pnlforgot:false})
 window.scrollTo({        top: 0     })					
		}
		
		else if(strreturn===2)
		{	
					this.setState({pnlmsg:true,msgtext:"Your account has been blocked. Please contact admin to activate",pnlforgot:false})	
					 window.scrollTo({        top: 0     })
		}
		}
		 
	 })
}
	 render(){
		  let msgtext=this.state.msgtext;
	 	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
	  return(
	<div className="contentseclog-col">
	
		 <div className="regform"><h2>Forgot Password</h2>
	  <p>  <Collapse in={this.state.erroropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alerttype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	   {this.state.pnlmsg===true && (
	  <div className="formright">
	  <div dangerouslySetInnerHTML={ { __html: msgtext}} className="messagetxt"/>
	  </div>
	  
	  )}
	   <p>
	 <TextField id="emailid" name="emailid"  variant="outlined"  className="signinpt"  placeholder="Your Email id"
            fullWidth inputProps={{maxLength:150,  }} 
			value={this.state.emailid}  onChange={this.handleChange}/> 
	 
	 </p> <p><Button
            type="submit"
            fullWidth
			disabled={this.state.btndisabled}
            variant="contained" 
    className="frmPrimarybtn"
           id="searchform" 
		onClick={this.OnclickForgot}
           
          >
           {this.state.btntext} 
          </Button>
		  </p>
		   <p className=" rememberlink">
	<a href="/Default" className="linkcolor">Sign In</a>
	 </p>
	  </div> </div>
	  )
	}
}

